import { Button, Snackbar } from "@mui/material";
import React from "react";
import MonitorCreateForm from "../Monitoring/MonitorCreateForm";
import EnableMonitoringButtonV2 from "../Monitoring/v2/EnrollmentButton";
import getAdminSetting from "../../utilities/getAdminSetting";

export interface Props {
  domain: string;
  disabled: boolean;
}

function EnableMonitoringButtonV1({ domain, disabled }: Props) {
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const [notificationOpen, setNotificationOpen] =
    React.useState<boolean>(false);
  return (
    <>
      <Button
        disabled={disabled}
        sx={{
          marginLeft: 2,
        }}
        variant="outlined"
        size="small"
        onClick={() => setModalOpen(true)}
      >
        Enable Monitoring
      </Button>
      <MonitorCreateForm
        open={modalOpen}
        onSubmit={() => {
          setModalOpen(false);
          setNotificationOpen(true);
        }}
        onClose={() => setModalOpen(false)}
        domain={domain}
      />
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={notificationOpen}
        autoHideDuration={5000}
        onClose={() => setNotificationOpen(false)}
        message="Monitor created"
      />
    </>
  );
}

export default function EnableMonitoringButtonV2OrV2({
  domain,
  disabled,
}: Props) {
  if (getAdminSetting("v2MonitoringUi") === true) {
    return (
      <EnableMonitoringButtonV2
        domain={domain}
        disabled={disabled}
        sx={{ marginLeft: 2 }}
      />
    );
  }

  return <EnableMonitoringButtonV1 domain={domain} disabled={disabled} />;
}
